import { QRCodeSVG } from 'qrcode.react';
import { withMfaLogo } from '@/lib/mfa-branding';

type MfaQrCodeProps = {
  uri: string;
  size: number;
};

/** QR code 2FA aux couleurs VisionPOS : logo « V » au centre + dans l'URI otpauth. */
export function MfaQrCode({ uri, size }: MfaQrCodeProps) {
  const logoSize = Math.round(size * 0.22);
  return (
    <QRCodeSVG
      value={withMfaLogo(uri)}
      size={size}
      level="H"
      marginSize={2}
      className="rounded-lg border bg-white"
      title="QR Code 2FA VisionPOS 360"
      imageSettings={{ src: '/icon-192.png', height: logoSize, width: logoSize, excavate: true }}
    />
  );
}
